export enum NamedStorages {
  'UserPreferenceStorage' = 'UserPreferenceStorage',
  'CentrePreferenceStorage' = 'CentrePreferenceStorage',
  'UserProvider' = 'UserProvider',
  'ReadmissionStorage' = 'ReadmissionStorage'
}